import "core-js/modules/es.array.concat";
import { deepExtract } from 'helpers/deep';
export var filterSetFilters = function filterSetFilters(state, filterSet) {
  return deepExtract("filterSets.".concat(filterSet, ".filters"), state, false);
};
export var filterSetFilterValue = function filterSetFilterValue(state, filterSet, filter) {
  return deepExtract("filterSets.".concat(filterSet, ".filters.").concat(filter, ".value"), state, undefined);
};
export var filterSetIsFiltered = function filterSetIsFiltered(state, filterSet) {
  return deepExtract("filterSets.".concat(filterSet, ".filtered"), state, false);
};